import React from 'react'
const AppContext = React.createContext()
export default AppContext


// WEBPACK FOOTER //
// ./client/src/AppContext.js